export const scoreBullet = [
  {
    color: 'currentColor',
    value: 3,
    text: 'Good',
    fillCount: 3,
  },
  {
    color: 'currentColor',
    value: 2,
    text: 'Medium',
    fillCount: 2,
  },
  {
    color: 'currentColor',
    value: 1,
    text: 'Poor',
    fillCount: 1,
  },
]

export const getConfidenceValue = (confidence: string | number | undefined) => {
  if (!confidence) return 0

  if (typeof confidence === 'number') {
    const value = confidence >= 1 && confidence <= 3 ? confidence : 0

    return value
  }

  const stringValue = confidence.trim().toLowerCase()

  switch (stringValue) {
    case 'poor':
      return 1
    case 'medium':
      return 2
    case 'good':
      return 3
    case '1':
    case '2':
    case '3':
      return Number(confidence)
    default:
      return 0
  }
}
